import script from "./CoachingSessionAboutCoach.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoachingSessionAboutCoach.vue?vue&type=script&lang=ts&setup=true"

import "./CoachingSessionAboutCoach.vue?vue&type=style&index=0&id=06ad0ab9&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ad0ab9"]])

export default __exports__